module.exports = __webpack_public_path__ + "img/art_6_1.0bcdcf66.jpg";